import React from "react";
import { useHistory } from "react-router-dom";
import { SideLogo } from "../../assets/svgs";
import christmasLogo from "../../assets/images/christmasLogoSingle.png";
import ChristmasLight from "../../assets/images/bannerLight.png";
import styles from "./auth_style.module.css";
import { checkIfChristmasPeriod } from "../../utils/checkIfChristmasPeriod";

export default function AuthPageWrapper({ children }) {
	const { push } = useHistory();
	return (
		<div
			className={`${styles.auth_container} d-flex justify-content-center text-center align-items`}
		>
			<div className={`${styles.auth_card} bg-white `}>
				{checkIfChristmasPeriod() && (
					<div className={styles.christmasLightContainer}>
						<img
							src={ChristmasLight}
							alt="christmas Light"
							className={`${styles.light}`}
						/>
					</div>
				)}
				<div className={`mt-5 pt-2 ${styles.logo}`}>
					{checkIfChristmasPeriod() ? (
						<img
							src={christmasLogo}
							alt="Abscohmat logo"
							onClick={() => push("/")}
							style={{ width: "84px" }}
						/>
					) : (
						<SideLogo
							onClick={() => push("/")}
							className={`${styles.loginLogo}`}
						/>
					)}
				</div>
				{children}
			</div>
		</div>
	);
}
